import IconButton from '../../Buttons/Icon/IconButton';
import IconLink from '../../Links/Icon/IconLink';
import Props from './typings';

const InstagramIcon = ({
  size = 16,
  title = 'Artfinder Instagram',
  action,
  url = 'https://instagram.com/artfinder_com/',
  style,
}: Props) => {
  return action ? (
    <IconButton
      icon="instagram"
      onClick={action}
      title={title}
      style={{
        icon: {size: size, color: {default: style?.color.default, hover: style?.color.hover}},
      }}
      data-test-id="instagram-icon"
    />
  ) : (
    <IconLink
      data-test-id="instagram-icon"
      icon="instagram"
      href={url}
      title={title}
      style={{
        size: size,
        color: {default: style?.color.default, hover: style?.color.hover},
      }}
      target="_blank"
      className="instagram-icon"
      rel="nofollow"
    />
  );
};

export default InstagramIcon;
